module.exports = __webpack_public_path__ + "img/POP-00009-2.8e05ee00.png";